import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SortingHelperService {

  sortArray<T extends string>(array: any[], field: T, direction: 'asc' | 'desc' = 'asc'): any[] {
    return array.sort((a, b) => {
      let valueA = this.resolveField(a, field);
      let valueB = this.resolveField(b, field);

      try {
        const numA = Number(String(valueA).replaceAll(',', ''));
        const numB = Number(String(valueB).replaceAll(',', ''));
        if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
          valueA = numA;
          valueB = numB;
        }
      }
      catch{}

      if (valueA < valueB) {
        return direction === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }
  sortArrayByGetter<T>(array: T[], getter: (row: T) => any, direction: 'asc' | 'desc' = 'asc'): T[] {
    const collator = new Intl.Collator('es', {
      sensitivity: 'base',
      numeric: true
    });
    const dir = direction === 'asc' ? 1 : -1;
    return [...array].sort((a: any, b: any) => {
      let va = getter(a);
      let vb = getter(b);
      const aNull = va == null || va === '';
      const bNull = vb == null || vb === '';
      if (aNull && bNull) return 0;
      if (aNull) return 1 * dir;
      if (bNull) return -1 * dir;
      const na = this.asNumberIfPossible(va);
      const nb = this.asNumberIfPossible(vb);
      if (na !== null && nb !== null) {
        return (na - nb) * dir;
      }
      const da = Date.parse(va);
      const db = Date.parse(vb);
      if (!Number.isNaN(da) && !Number.isNaN(db)) {
        return ((da as number) - (db as number)) * dir;
      }
      return collator.compare(String(va), String(vb)) * dir;
    });
  }

  private resolveField(object: any, field: string): any {
    return field.split('.').reduce((o, key) => (o ? o[key] : null), object);
  }

  private asNumberIfPossible(raw: any): number | null {
    if (raw == null) return null;
    const s = String(raw).trim();
    if (!s) return null;
    const t1 = Number(s.replace(/,/g, ''));
    if (!Number.isNaN(t1)) return t1;
    const t2 = Number(s.replace(/\./g, '').replace(',', '.'));
    if (!Number.isNaN(t2)) return t2;
    return null;
  }
}
